export const ITEM_OUT_OF_STOCK = 'Item is out of stock';
export const PURCHASING_DISABLED = 'Purchasing for this item has been disabled';
export const GREATER_SELECTED_QUANTITY = 'Selected Quantity is greater than Available quantity';
